import { createTheme } from "@mui/material/styles";
import "@fontsource/raleway";

declare module "@mui/material/styles" {
    interface Palette {
        transparent: {
            main: string;
        };
    }
    interface PaletteOptions {
        transparent?: {
            main: string;
        };
    }
}

const theme = createTheme({
    palette: {
        primary: {
            main: "#3CA3FE",
            dark: "#026BC7",
        },
        secondary: {
            main: "#9A9A9A",
            dark: "#707070",
        },
        common: {
            black: "#0C0C20",
            white: "#F6FAF9",
        },
        success: {
            main: "#2A9928",
        },
        error: {
            main: "#FF3B30",
        },
        warning: {
            main: "#FFCC00",
        },
        transparent: {
            main: "transparent !important",
        },
    },
    typography: {
        fontFamily: "'Raleway', sans-serif",
        body1: {
            fontFamily: "'Raleway', sans-serif",
            fontSize: "16px",
        },
        body2: {
            fontFamily: "'Raleway', sans-serif",
            fontSize: "14px",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    textTransform: "none",
                    color: "white",
                },
            },
        },
    },
});

export default theme;
